import { createContext } from 'react'
import { initialState } from './reducer'

export const initialContextState = {
  /**
   *
   * @param {ReactNode} message - The message to display in the snackbar.
   * @param {"error" | "info" | "success" | "warning" | "default"} [severity='default'] - The severity level of the snackbar (e.g., 'default', 'success', 'error').
   * @param {function} [onClose]
   */
  createSnackbar: (message, severity = 'default', onClose = null) => {},
  state: initialState,
}

const SnackbarContext = createContext(initialContextState)

export default SnackbarContext
